module.exports = __webpack_public_path__ + "static/media/logo.a382f189.png";